<div class="modal-body text-center" >
  <p *ngIf="!error && (!authWindow || authWindow && !authWindow.closed)">
  Logging in progress
  </p>
  <p *ngIf="error">
      {{ error }}
  </p>
  <p *ngIf="authWindow && authWindow.closed">
      Authentication window was closed
  </p>
</div>
<div class="modal-footer" *ngIf="authWindow && authWindow.closed || error">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">Close</button>
</div>